import { ServicoEdicaoRequest, ServicosApiResponse } from "../@types/servicos";
import { GenericActionResponse } from "../@types";
import apiFinanceiro from "./api-financeiro.service";
export function obterServicos(): Promise<ServicosApiResponse> {
  return apiFinanceiro.get("/servicos/");
}

export function obterServicosPorTextoDeBusca(
  textoBusca: string
): Promise<ServicosApiResponse> {
  return apiFinanceiro.get(
    `/servicos/buscar-por-campos?textoDeBusca=${textoBusca}`
  );
}

export function atualizarServico(
  id: number,
  servico: ServicoEdicaoRequest
): Promise<GenericActionResponse> {
  return apiFinanceiro.put(`/servicos/${id}`, servico);
}